var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBigquery = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4386FA",
    fillRule: "evenodd",
    d: "m10.144 34.822-7.83-13.644a2.37 2.37 0 0 1 0-2.356l7.83-13.644A2.34 2.34 0 0 1 12.17 4h15.67a2.34 2.34 0 0 1 2.017 1.178l7.83 13.644a2.37 2.37 0 0 1 0 2.356l-7.83 13.644A2.34 2.34 0 0 1 27.83 36H12.166a2.34 2.34 0 0 1-2.02-1.178Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C79E1",
    fillRule: "evenodd",
    d: "M24.892 15.607s2.177 5.252-.79 8.23c-2.969 2.976-8.372 1.071-8.372 1.071s8.033 8.187 10.993 11.088h1.116a2.34 2.34 0 0 0 2.025-1.178l5.184-9.03z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.651 21.62v-2.045l1.315-.013v3.402a3.63 3.63 0 0 1-1.315-1.344m2.461-3.742v5.529c.435.08.88.08 1.315 0v-5.53h-1.315Zm3.806 2.526v1.212a3.63 3.63 0 0 1-1.316 1.34v-2.552z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m25.057 23.934 2.406 2.42a.38.38 0 0 1 0 .536l-.63.634a.375.375 0 0 1-.533 0l-2.406-2.42a.4.4 0 0 1-.063-.085 6.514 6.514 0 0 1-8.924-.802 6.61 6.61 0 0 1 .243-9.01 6.513 6.513 0 0 1 8.955-.312 6.607 6.607 0 0 1 .863 8.971.4.4 0 0 1 .089.068m-10.181-4.096c0 2.735 2.203 4.95 4.921 4.95a4.9 4.9 0 0 0 3.48-1.449 4.97 4.97 0 0 0 1.442-3.5c0-2.735-2.204-4.951-4.922-4.951s-4.921 2.216-4.921 4.95",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigquery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bigquery.7b1d6849.svg";